export default "__VITE_ASSET__DdhNlE$___"